import React from 'react';
import {
  Box,
  Container,
  Typography,
  Avatar,
  IconButton,
} from '@mui/material';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import LanguageIcon from '@mui/icons-material/Language';
import EmailIcon from '@mui/icons-material/Email';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import ChatInterface from '../components/Chat/ChatInterface';
import { useNavigate } from 'react-router-dom';

const ModernHome = () => {
  const navigate = useNavigate();

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#1e1e2e' }}>
      {/* Botón Admin flotante */}
      <IconButton
        sx={{
          position: 'fixed',
          top: 20,
          right: 20,
          bgcolor: 'rgba(52, 152, 219, 0.9)',
          color: 'white',
          zIndex: 1000,
          '&:hover': {
            bgcolor: '#3498db',
          },
        }}
        onClick={() => navigate('/login')}
      >
        <AdminPanelSettingsIcon />
      </IconButton>

      {/* Hero Section con foto */}
      <Box
        sx={{
          background: 'linear-gradient(135deg, #2c3e50 0%, #3498db 100%)',
          py: 6,
          px: 3,
          textAlign: 'center',
          position: 'relative',
          overflow: 'hidden',
          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.3)',
        }}
      >
        <Container maxWidth="md">
          <Box sx={{ position: 'relative', zIndex: 1 }}>
            {/* Avatar con foto */}
            <Avatar
              src="/german_mallo_pic.PNG"
              alt="Germán Mallo"
              sx={{
                width: 100,
                height: 100,
                mx: 'auto',
                mb: 2,
                border: '4px solid rgba(255, 255, 255, 0.3)',
                boxShadow: '0 4px 20px rgba(0, 0, 0, 0.3)',
              }}
            />

            <Typography variant="h4" sx={{ fontWeight: 700, mb: 1 }}>
              Germán Mallo Faure
            </Typography>
            <Typography variant="h6" sx={{ fontWeight: 500, mb: 3, opacity: 0.9 }}>
              Data Scientist
            </Typography>

            {/* Social Links */}
            <Box sx={{ display: 'flex', justifyContent: 'center', gap: 1 }}>
              <IconButton
                size="medium"
                sx={{ 
                  color: 'white',
                  bgcolor: 'rgba(255, 255, 255, 0.1)',
                  '&:hover': { bgcolor: 'rgba(255, 255, 255, 0.2)' }
                }}
                href="https://www.linkedin.com/in/germ%C3%A1n-mallo-faure/"
                target="_blank"
              >
                <LinkedInIcon />
              </IconButton>
              <IconButton
                size="medium"
                sx={{ 
                  color: 'white',
                  bgcolor: 'rgba(255, 255, 255, 0.1)',
                  '&:hover': { bgcolor: 'rgba(255, 255, 255, 0.2)' }
                }}
                href="https://germanmallo.com"
                target="_blank"
              >
                <LanguageIcon />
              </IconButton>
              <IconButton
                size="medium"
                sx={{ 
                  color: 'white',
                  bgcolor: 'rgba(255, 255, 255, 0.1)',
                  '&:hover': { bgcolor: 'rgba(255, 255, 255, 0.2)' }
                }}
                href="mailto:germanmallo04@gmail.com"
              >
                <EmailIcon />
              </IconButton>
            </Box>
          </Box>
        </Container>
      </Box>

      {/* Chat Section */}
      <Container maxWidth="md" sx={{ py: 4 }}>
        <Box sx={{ mb: 3, textAlign: 'center' }}>
          <SmartToyIcon sx={{ fontSize: 48, color: '#3498db', mb: 2 }} />
          <Typography variant="h5" sx={{ fontWeight: 700, mb: 1 }}>
            Asistente Virtual con IA
          </Typography>
          <Typography variant="body1" sx={{ color: 'rgba(255, 255, 255, 0.7)', mb: 3 }}>
            Pregúntame sobre mi experiencia, proyectos, habilidades o cualquier aspecto de mi perfil
            profesional
          </Typography>
        </Box>

        <ChatInterface />
      </Container>
    </Box>
  );
};

export default ModernHome;
